
import { Html, useProgress } from "@react-three/drei"

//FOR SHOWING THE LOADING OF THE COMPUTER

const CanvasLoader = () => {
  const { progress } = useProgress();

  return (
    <Html>
      <span className='canvas-loader'></span>
      <p
        style={{
          fontSize: 14,
          color: "#F1F1F1",
          fontWeight: 800,
          marginTop: 40,
        }}
      >
        {progress.toFixed(2)}%
      </p>
    </Html>
  )
}

export default CanvasLoader;